/* FitControl — interacciones de la tienda (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scriptAssetBase = (function () {
    var script = document.currentScript || document.querySelector('script[src*="fc-scripts.js"]');
    if (!script || !script.src) return '/cdn/shop/t/3/assets/';
    return script.src.split('?')[0].replace(/fc-scripts\.js$/, '');
  })();

  function assetUrl(file) {
    return scriptAssetBase + file;
  }

  function setText(el, text) {
    if (el && typeof text === 'string') el.textContent = text;
  }

  function setHtml(el, html) {
    if (el && typeof html === 'string') el.innerHTML = html;
  }

  function initReveals() {
    var els = document.querySelectorAll('.fc-reveal, .fc-stagger');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-countup'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        var raw = el.getAttribute('data-countup') || '0';
        var target = parseFloat(raw) || 0;
        var dec = (raw.split('.')[1] || '').length;
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1100, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.fc-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.fc-faq__q');
      var a = item.querySelector('.fc-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        item.classList.toggle('open');
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  function initGearKits() {
    var sections = document.querySelectorAll('[data-fc-gear]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var cards = section.querySelectorAll('[data-fc-gear-card]');
      var title = section.querySelector('[data-fc-gear-title]');
      var body = section.querySelector('[data-fc-gear-body]');
      var products = section.querySelector('[data-fc-gear-products]');
      var metric = section.querySelector('[data-fc-gear-metric]');
      var metricLabel = section.querySelector('[data-fc-gear-metric-label]');
      var cue = section.querySelector('[data-fc-gear-cue]');
      var cta = section.querySelector('[data-fc-gear-cta]');
      var orb = section.querySelector('[data-fc-gear-orb]');
      var focus = section.querySelector('[data-fc-gear-focus]');

      function selectCard(card) {
        cards.forEach(function (item) {
          var active = item === card;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (title) title.textContent = card.getAttribute('data-title') || '';
        if (body) body.textContent = card.getAttribute('data-body') || '';
        if (metric) metric.textContent = card.getAttribute('data-metric') || '';
        if (metricLabel) metricLabel.textContent = card.getAttribute('data-metric-label') || '';
        if (orb) orb.textContent = card.getAttribute('data-icon') || '';
        if (cue) cue.textContent = card.getAttribute('data-cue') || '';
        if (cta) {
          cta.textContent = card.getAttribute('data-cta-text') || cta.textContent;
          cta.setAttribute('href', card.getAttribute('data-cta-url') || '#');
        }
        if (products) {
          products.innerHTML = (card.getAttribute('data-products') || '').replace(/\n/g, '<br>');
        }

        if (focus && !reduce) {
          focus.animate(
            [{ transform: 'translateY(8px)', opacity: 0.82 }, { transform: 'translateY(0)', opacity: 1 }],
            { duration: 220, easing: 'cubic-bezier(.22,1,.36,1)' }
          );
        }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { selectCard(card); });
        card.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectCard(card);
          }
        });
      });
    });
  }

  function initGearPicks() {
    var sections = document.querySelectorAll('[data-fc-picks]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.fcPicksReady === 'true') return;
      upgradeCachedGearPicks(section);
      section.dataset.fcPicksReady = 'true';
      var filters = section.querySelectorAll('[data-fc-pick-filter]');
      var cards = section.querySelectorAll('[data-fc-pick-card]');
      var count = section.querySelector('[data-fc-picks-count]');
      var empty = section.querySelector('[data-fc-picks-empty]');
      if (!filters.length || !cards.length) return;

      function applyFilter(value) {
        var visible = 0;

        filters.forEach(function (button) {
          var active = button.getAttribute('data-fc-pick-filter') === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        cards.forEach(function (card) {
          var show = value === 'all' || card.getAttribute('data-stage') === value;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (count) count.textContent = visible;
        if (empty) empty.hidden = visible !== 0;
      }

      filters.forEach(function (button) {
        button.addEventListener('click', function () {
          applyFilter(button.getAttribute('data-fc-pick-filter') || 'all');
        });
      });
    });
  }

  function upgradeCachedGearPicks(section) {
    if (section.dataset.fcBuyerCopy === 'true') return;
    var stale = section.textContent.indexOf('Product link lab') !== -1 ||
      section.textContent.indexOf('Votar este pick') !== -1 ||
      section.textContent.indexOf('Affiliate direct') !== -1;
    if (!stale) return;
    section.dataset.fcBuyerCopy = 'true';

    setText(section.querySelector('.fc-picks__copy .fc-eyebrow'), 'Seleccion FitControl');
    setText(section.querySelector('.fc-picks__copy h2'), 'Productos recomendados para entrenar con criterio');
    setText(
      section.querySelector('.fc-picks__copy p'),
      'Equipamiento externo elegido para que no compres a ciegas. Abres el producto en la tienda oficial y aqui te llevas la guia FitControl: que comprar, como usarlo y para que nivel encaja.'
    );

    var board = section.querySelector('.fc-picks__board');
    if (board) {
      setText(board.querySelector(':scope > span'), 'Seleccion FitControl');
      var labels = board.querySelectorAll('small');
      setText(labels[0], 'productos revisados');
      setText(labels[1], 'picks principales');
      setText(labels[2], 'productos recomendados');
    }

    var filters = section.querySelectorAll('[data-fc-pick-filter]');
    filters.forEach(function (button) {
      var filter = button.getAttribute('data-fc-pick-filter');
      if (filter === 'first') setText(button, 'Mejor para empezar');
      if (filter === 'shortlist') setText(button, 'Bandas y movilidad');
      if (filter === 'research') setText(button, 'Home gym');
    });

    var count = section.querySelector('[data-fc-picks-count]');
    if (count && count.parentElement) {
      count.parentElement.innerHTML = '<span data-fc-picks-count>' + count.textContent + '</span> productos visibles';
    }

    var products = {
      'Living.Fit Resistance Bands': {
        route: 'Partner recomendado',
        stage: 'Mejor para empezar',
        summary: 'Bandas versatiles para movilidad, gluteo y progresiones en casa. Buena primera compra si quieres seguir rutinas guiadas sin montar un gimnasio.',
        tags: ['Movilidad', 'Gluteo', 'Casa'],
        stack: ['Calentamientos guiados', 'Progresiones con bandas', 'Contenido de tecnica y setup'],
        value: 'Incluye criterio de uso: que banda elegir, como calentar y como progresar sin improvisar.',
        price: '$69.99',
        risk: 'Revisar resistencia y stock',
        productText: 'Ver producto recomendado',
        guideText: 'Quiero la guia',
        url: 'https://www.living.fit/collections/resistance-bands/products/resistance-bands',
        visual: 'Band set',
        caption: 'Mobility + Glute',
        alt: 'Foto oficial de Living.Fit Resistance Bands',
        image: 'https://www.living.fit/cdn/shop/files/106.png?v=1780532436'
      },
      'TRX HOME2 SYSTEM': {
        route: 'Partner premium',
        stage: 'Mejor para empezar',
        summary: 'Sistema de suspension para fuerza relativa, core y movilidad en casa. Ideal si buscas una herramienta duradera con muchas progresiones.',
        tags: ['Core', 'Casa', 'Premium'],
        stack: ['Rutinas en espacio pequeno', 'Progresiones por nivel', 'Setup antes de entrenar'],
        value: 'Te orienta sobre donde anclarlo, que nivel empezar y como usarlo sin comprar accesorios de mas.',
        price: '$239.95',
        risk: 'Confirmar app y anclaje',
        productText: 'Ver producto recomendado',
        guideText: 'Quiero rutina TRX',
        url: 'https://www.trxtraining.com/products/home-gym',
        visual: 'TRX Home2',
        caption: 'Suspension trainer',
        alt: 'Foto oficial de TRX HOME2 SYSTEM',
        image: 'https://www.trxtraining.com/cdn/shop/products/TRXHome2-5-21-21v21312_R2.jpg?v=1760621193'
      },
      'SuperFlex Functional Training Bands Package': {
        route: 'Pack recomendado',
        stage: 'Bandas y movilidad',
        summary: 'Pack simple para movilidad, viajes y sesiones ligeras. Facil de entender si necesitas una banda por nivel sin complicarte.',
        tags: ['Viaje', 'Movilidad', 'Pack'],
        stack: ['FT1 / FT2 / FT3', 'Guia por niveles', 'Calentamiento rapido'],
        value: 'Incluye explicacion de que banda usar, cuando subir resistencia y como meterlo en tu rutina.',
        price: '$39.95',
        risk: 'Confirmar contenido del pack',
        productText: 'Ver producto recomendado',
        guideText: 'Quiero guia de bandas',
        url: 'https://www.superflexfitness.com/shop/functional-training-bands-package/',
        visual: 'SuperFlex',
        caption: '3-band package',
        alt: 'Foto oficial del paquete SuperFlex Functional Training Bands',
        image: 'https://www.superflexfitness.com/wp-content/uploads/2013/10/functional-training-package1.jpg'
      },
      'FitCord Body Sculpting Band Singles': {
        route: 'Opcion tecnica',
        stage: 'Bandas y movilidad',
        summary: 'Bandas cubiertas con clips para quien prefiere mas control y accesorios. Buena opcion si quieres progresiones con agarres.',
        tags: ['Clips', 'Progresion', 'Accesorio'],
        stack: ['Guia de resistencia', 'Compatibilidad con agarres', 'Uso conservador'],
        value: 'Te ayuda a elegir resistencia y accesorios sin prometer seguridad absoluta ni resultados milagro.',
        price: '$24-$34',
        risk: 'Revisar terminos y claims',
        productText: 'Ver producto recomendado',
        guideText: 'Quiero guia de bandas',
        url: 'https://fitcord.com/collections/shop-all-products/products/body-sculpting-band-singles',
        visual: 'FitCord',
        caption: 'Covered bands',
        alt: 'Foto oficial de FitCord Body Sculpting Band Singles',
        image: 'https://cdn.shopify.com/s/files/1/0032/3721/6345/products/body-sculpting-band-single-828985.jpg?v=1780766020'
      },
      'TRX Bandit + Strength Bands': {
        route: 'Complemento TRX',
        stage: 'Bandas y movilidad',
        summary: 'Agarres y bandas para ampliar rutinas si ya vienes de TRX o quieres una guia de bandas mas completa.',
        tags: ['Agarres', 'Bandas', 'Cross-sell'],
        stack: ['Selector por nivel', 'Complemento Home2', 'Rutina de bandas'],
        value: 'Te separa el uso de Bandit y strength bands para no comprar variantes que no necesitas.',
        price: '$16.95-$161.96',
        risk: 'Revisar variantes',
        productText: 'Ver TRX Bandit',
        guideText: 'Quiero selector',
        url: 'https://www.trxtraining.com/products/bandit',
        secondaryText: 'Ver strength bands',
        secondaryUrl: 'https://www.trxtraining.com/products/strength-bands',
        visual: 'TRX Bands',
        caption: 'Accessories',
        alt: 'Foto oficial de TRX Bandit',
        image: 'https://www.trxtraining.com/cdn/shop/products/TRX-Bandit.jpg?v=1760621210'
      },
      'Rogue / Titan high-ticket guide': {
        newTitle: 'Rogue + Titan dumbbells guide',
        route: 'Guia de compra',
        stage: 'Home gym',
        summary: 'Opcion de home gym para comparar dumbbells de ticket alto antes de comprar. Solo se recomienda tras revisar espacio, envio y garantia.',
        tags: ['Home gym', 'Comparativa', 'Alto ticket'],
        stack: ['Comparativa de dumbbells', 'No inventario inicial', 'Modelos con recall fuera'],
        value: 'Te ayuda a comparar Rogue y Titan sin empujar compra impulsiva de alto ticket.',
        price: 'Por revisar',
        risk: 'Revisar envio y garantia',
        productText: 'Ver Rogue dumbbells',
        guideText: 'Quiero comparativa',
        url: 'https://www.roguefitness.com/rogue-loadable-dumbbells',
        secondaryText: 'Ver Titan dumbbells',
        secondaryUrl: 'https://titan.fitness/products/200-lb-set-adjustable-chrome-dumbbells',
        visual: 'Home gym',
        caption: 'Dumbbells',
        alt: 'Foto oficial de Rogue Loadable Dumbbells',
        image: 'https://assets.roguefitness.com/f_auto,q_auto,c_limit,w_1600,b_rgb:ffffff/catalog/Conditioning/Strength%20Equipment/Dumbbells/LOADABLEDBS/Loadable-Dumbbell-H-GFX_a01xbu.png'
      }
    };

    section.querySelectorAll('[data-fc-pick-card]').forEach(function (card) {
      var heading = card.querySelector('h3');
      if (!heading) return;
      var currentTitle = heading.textContent.trim();
      var data = products[currentTitle];
      if (!data) return;

      setText(card.querySelector('.fc-pick-card__route'), data.route);
      setText(card.querySelector('.fc-pick-card__stage'), data.stage);
      setHtml(heading, '<a href="' + data.url + '" target="_blank" rel="noopener sponsored nofollow" style="color:inherit;text-decoration:none;">' + (data.newTitle || currentTitle) + '</a>');
      setText(heading.nextElementSibling, data.summary);

      var visual = card.querySelector('.fc-pick-card__visual');
      if (visual) {
        var image = /^https?:\/\//.test(data.image) ? data.image : assetUrl(data.image);
        var visualHtml = '<img src="' + image + '" alt="' + (data.alt || ('Foto oficial de ' + data.visual)) + '" loading="lazy" style="position:absolute;inset:10px 14px 34px;width:calc(100% - 28px);height:calc(100% - 48px);object-fit:contain;opacity:.96;background:#f5f7fa;border-radius:12px;">' +
          '<span style="position:relative;z-index:1;">' + data.visual + '</span>' +
          '<small style="position:relative;z-index:1;">' + data.caption + '</small>' +
          '<em style="position:absolute;right:14px;top:14px;z-index:2;border-radius:999px;padding:8px 12px;background:linear-gradient(135deg,#bce000,#15c2b0);color:#0a0b0f;font-style:normal;font-size:.74rem;font-weight:950;text-transform:uppercase;">' + data.productText + '</em>';
        var visualLink = document.createElement('a');
        visualLink.className = visual.className;
        visualLink.href = data.url;
        visualLink.target = '_blank';
        visualLink.rel = 'noopener sponsored nofollow';
        visualLink.setAttribute('aria-label', data.productText + ': ' + (data.newTitle || currentTitle));
        visualLink.style.position = 'relative';
        visualLink.style.minHeight = '150px';
        visualLink.style.textDecoration = 'none';
        visualLink.style.color = 'inherit';
        visualLink.innerHTML = visualHtml;
        visual.replaceWith(visualLink);
      }

      var quicklinks = card.querySelector('.fc-pick-card__quicklinks');
      if (!quicklinks) {
        quicklinks = document.createElement('div');
        quicklinks.className = 'fc-pick-card__quicklinks';
        quicklinks.style.display = 'flex';
        quicklinks.style.flexWrap = 'wrap';
        quicklinks.style.gap = '8px';
        quicklinks.style.marginTop = '-2px';
        if (heading.nextElementSibling) heading.nextElementSibling.insertAdjacentElement('afterend', quicklinks);
      }
      quicklinks.innerHTML = '<a href="' + data.url + '" target="_blank" rel="noopener sponsored nofollow" style="border:1px solid rgba(188,224,0,.45);border-radius:999px;padding:7px 10px;color:#bce000;text-decoration:none;font-size:.78rem;font-weight:900;">' + data.productText + '</a>' +
        (data.secondaryUrl ? '<a href="' + data.secondaryUrl + '" target="_blank" rel="noopener sponsored nofollow" style="border:1px solid rgba(34,211,238,.38);border-radius:999px;padding:7px 10px;color:#22d3ee;text-decoration:none;font-size:.78rem;font-weight:900;">' + data.secondaryText + '</a>' : '');

      var business = card.querySelector('.fc-pick-card__business');
      if (!business) {
        business = document.createElement('div');
        business.className = 'fc-pick-card__business';
        business.style.border = '1px solid rgba(188,224,0,.22)';
        business.style.borderLeft = '3px solid #bce000';
        business.style.borderRadius = '14px';
        business.style.padding = '12px 14px';
        business.style.background = 'rgba(10,11,15,.55)';
        business.style.display = 'grid';
        business.style.gap = '6px';
        quicklinks.insertAdjacentElement('afterend', business);
      }
      business.innerHTML = '<span style="color:#939db2;font-size:.72rem;font-weight:900;text-transform:uppercase;">Valor FitControl</span><strong style="color:#f4f6fb;line-height:1.42;">' + data.value + '</strong>';

      var tags = card.querySelector('.fc-pick-card__tags');
      if (tags) tags.innerHTML = data.tags.map(function (tag) { return '<span>' + tag + '</span>'; }).join('');

      var stack = card.querySelector('.fc-pick-card__stack');
      if (stack) {
        setText(stack.querySelector('span'), 'Guia FitControl');
        setHtml(stack.querySelector('strong'), data.stack.join('<br>'));
      }

      var metaTerms = card.querySelectorAll('.fc-pick-card__meta dt');
      var metaValues = card.querySelectorAll('.fc-pick-card__meta dd');
      setText(metaTerms[0], 'Precio proveedor');
      setText(metaTerms[1], 'Antes de comprar');
      setText(metaValues[0], data.price);
      setText(metaValues[1], data.risk);

      var actionLinks = card.querySelectorAll('.fc-pick-card__actions a');
      if (actionLinks[0]) {
        actionLinks[0].href = data.url;
        actionLinks[0].target = '_blank';
        actionLinks[0].rel = 'noopener sponsored nofollow';
        setText(actionLinks[0], data.productText);
      }
      if (data.secondaryUrl && actionLinks.length < 3) {
        var secondary = document.createElement('a');
        secondary.className = 'fc-btn fc-btn--ghost';
        secondary.href = data.secondaryUrl;
        secondary.target = '_blank';
        secondary.rel = 'noopener sponsored nofollow';
        secondary.textContent = data.secondaryText;
        if (actionLinks[0]) actionLinks[0].insertAdjacentElement('afterend', secondary);
      }
      actionLinks = card.querySelectorAll('.fc-pick-card__actions a');
      var guide = actionLinks[actionLinks.length - 1];
      if (guide) {
        guide.href = '#fitcontrol-waitlist';
        guide.removeAttribute('target');
        guide.removeAttribute('rel');
        setText(guide, data.guideText);
      }
    });

    var disclosure = section.querySelector('.fc-picks__disclosure');
    if (disclosure) {
      setText(disclosure, 'Disclosure: los productos se compran en la tienda oficial del proveedor. FitControl puede recibir comision si se activa un acuerdo afiliado, sin cambiar el precio para el usuario. Las fotos se cargan desde paginas oficiales del proveedor cuando estan disponibles; los renders FitControl quedan como fallback hasta tener assets aprobados por partner.');
    }
  }

  function initWaitlist() {
    var forms = document.querySelectorAll('[data-fc-waitlist]');
    if (!forms.length) return;

    forms.forEach(function (section) {
      var goal = section.querySelector('[data-fc-waitlist-goal]');
      var kit = section.querySelector('[data-fc-waitlist-kit]');
      var note = section.querySelector('[data-fc-waitlist-note]');
      if (!goal || !kit || !note) return;

      function syncNote() {
        note.value = 'Objetivo: ' + goal.value + ' | Kit: ' + kit.value + ' | Origen: homepage FitControl Gear';
      }

      goal.addEventListener('change', syncNote);
      kit.addEventListener('change', syncNote);
      syncNote();
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initReveals(); initCountUp(); initFaq(); initGearKits(); initGearPicks(); initWaitlist(); });
})();
